export const obterCollapseItems = ({ collapsedItems }) => {
  return collapsedItems
}
